import { render } from "./LoaderProfile.vue?vue&type=template&id=4396c688"
const script = {}
script.render = render

export default script